<app-page-content>
<app-doenkids-menu-bar menuBar [showBackButton]="true"></app-doenkids-menu-bar>
<div content>
  @if ((id$ | async); as id) {
    <app-review-overview [id]="id"></app-review-overview>
  }
</div>
</app-page-content>
